import { CardStatus } from '../types';
export const determineCardStatus = (beneficiary, hasActiveRechargeHistory = false) => {
    if (beneficiary.cardIssued !== undefined) {
        return beneficiary.cardIssued ? CardStatus.ISSUED : CardStatus.NOT_ISSUED;
    }
    if (hasActiveRechargeHistory && beneficiary.statusInProduct === 'ACTIVE') {
        return CardStatus.ISSUED;
    }
    return CardStatus.NOT_ISSUED;
};
export const hasSelectedBeneficiaryWithoutCard = (selected, beneficiaries) => {
    const beneficiariesById = new Map(beneficiaries.map(beneficiary => [beneficiary.id, beneficiary]));
    return selected.some(({ beneficiaryId }) => {
        const beneficiary = beneficiariesById.get(beneficiaryId);
        return !beneficiary || determineCardStatus(beneficiary) === CardStatus.NOT_ISSUED;
    });
};
export const countSelectedBeneficiariesWithoutCard = (selected, beneficiaries) => {
    const cardIssuedById = new Map(beneficiaries.map(beneficiary => [beneficiary.id, beneficiary.cardIssued]));
    const needsCard = ({ beneficiaryId, cardIssued }) => (cardIssued ?? cardIssuedById.get(beneficiaryId)) !== true;
    return selected.filter(needsCard).length;
};
export const CARD_STATUS_FILTER_LABEL_KEYS = {
    [CardStatus.ISSUED]: 'beneficiary-filter.card-status.issued',
    [CardStatus.NOT_ISSUED]: 'beneficiary-filter.card-status.not-issued',
};
export const toCardIssuedFilter = (cardStatus) => {
    if (cardStatus.length !== 1) {
        return undefined;
    }
    return cardStatus[0] === CardStatus.ISSUED;
};
export const getCardStatusTooltip = (cardStatus) => {
    switch (cardStatus) {
        case CardStatus.ISSUED:
            return 'benefits.card-status.tooltip.issued';
        case CardStatus.NOT_ISSUED:
            return 'benefits.card-status.tooltip.not-issued';
        default:
            return 'benefits.card-status.tooltip.unknown';
    }
};
